export enum ContentManagementComponentEnum {
  ADMISSION_RULES = 'Admission Rules',
  DECLARATION_RULES = 'Declaration Rules',
  DOCUMENT_UPLOAD_RULES = 'Document Upload Rules',
  ADMISSION_FEE_NOTES = 'Admission Fee Notes',
}
